module.exports = __webpack_public_path__ + "static/media/receipt-fill.9cd9bc30.svg";